import useStudiesErrorState, { StudiesErrorKind } from 'utils/hooks/flux/personalized/useStudiesErrorState';

export type OverviewErrorKind = StudiesErrorKind;

/**
 * Erro de UMA parte da Visão Geral (indicadores, mapa ou tabela), tratado no lugar (#2009, item 2).
 *
 * Antes, cada hook chamava o `useHandleRequestErrors`: qualquer falha (ex.: o 503 da fonte
 * lenta, ~100 s depois) levava a página inteira para /error e zerava o cache, mesmo com o
 * mapa e a tabela já carregados. Agora falha de rede ou de servidor fica na parte que falhou,
 * com "Tentar novamente"; sessão expirada e 403 de permissão saem da página como antes.
 *
 * Reaproveita a regra do Flux Personalizado (`useStudiesErrorState`, #1984) no modo `primary`:
 * mesma classificação e um evento no Sentry por sequência de falhas.
 *
 * Durante o "Tentar novamente" o RTK Query mantém o erro anterior até a resposta nova;
 * com `isFetching`, a parte volta ao próprio carregamento em vez de deixar o aviso parado.
 */
export default function useOverviewErrorState(
  error: unknown,
  isFetching: boolean,
): OverviewErrorKind | null {
  const kind = useStudiesErrorState(error, { mode: 'primary' });
  return isFetching ? null : kind;
}
